/**
 * Session handler for local store.
 */
import { submitRegistration, submitResetPasswordRequest, submitResetPassword } from '~/utils/auth';
import { getCookie } from '~/utils/cookies';
import {
  reloadNuxtApp,
  useAuthStore,
  useCartStore,
  useUserStore
} from '#imports';

export function loadStores() {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const cartStore = useCartStore();

  return { authStore, userStore, cartStore };
}

export async function registrationHandler({ firstName, lastName, email, password, captchaToken }) {
   return await submitRegistration({ firstName, lastName, email, password, captchaToken })
}

export async function resetPasswordRequestHandler({ username }) {
  return await submitResetPasswordRequest({ username })
}

export async function loginHandler({ username, password, captchaToken }) {

  const { authStore } = loadStores();
  const result = await authStore.authenticateUser({ username, password, captchaToken });

  if (result?.data?.loginWithCookies?.status === 'SUCCESS') {
    await getUserSessionData();
    return true;
  }

  return false;
}

export async function resetPasswordHandler({ login, password, key }) {
  return await submitResetPassword({ login, password, key })
}

export async function getUserSessionData() {
  const { authStore, userStore, cartStore } = loadStores();
  let userExists = false;

  // fetch cart from server could be guest cart if no user
  cartStore.setCartFromSession().then(() => null);

  // fetch current user
  try {
    userExists = await userStore.setUserFromSession();
  } catch (error) {
    clearUserSession();

    return null;
  }

  if (userExists) {
    authStore.validateSession();
    return true;
  }

  return false;
}

function clearUserSession() {
  const userStore = useUserStore();

  userStore.invalidateSession();
}

export async function logoutHandler() {
  const { authStore } = loadStores()

  await authStore.logoutUser()

  this.clearUserSession()

  // refresh browser
  reloadNuxtApp({ path: '/' })
}
